import { makeStyles } from "@material-ui/styles";
import { dashboardStyle } from "../Components/InvoiceDetails/style";
import React, { useState, useEffect, useRef } from "react";
import TaxDetail from "../Components/TaxDetails/TaxDetails";
import { Delete, Error } from "@material-ui/icons";
import { Download } from "@material-ui/icons";
import axios from "axios";
import {
  Grid,
  TextField,
  Autocomplete,
  Typography,
  Backdrop,
  CircularProgress,
  IconButton,
  FormControl,
  Button,
  Box,
  InputAdornment,
  Select,
  MenuItem,
  Chip,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@material-ui/core";
import AttachmentsCover from "../../../components/Attachments/AttachmentsCover";
import {
  getCommentsByInvoiceId,
  getInvoiceByInvoiceIdAndRoleId,
  getVendorByPO,
  getAllInvoiceDetailByInvoiceId,
  getAllInvoiceDetailByInvoiceIdForDCReviewer,
  vendorTaxDetailForCnic,
  changeInvoiceStatus,
  getRefrenceDataList,
  uploadAdditioalDocumentFile,
  putDeptCoordinatorAndReviewerInvoice,
  getUsersByRole,
  getCostCenterData,
  getMethodForPageRefresh,
  createNewInvoice,
} from "../actions";
import { getAllInvoiceDetailByInvoiceIdV2 } from "../ProcessInvoice/actions";
import InvoiceRadioButtons from "../Components/InvoiceDetails/InvoiceRadiobuttons";
import InvoiceTextField from "../Components/InvoiceDetails/InvoiceTextFields";
import InvoiceCheckboxes from "../Components/InvoiceDetails/InvoiceCheckboxes";
import Card from "../../../StyledComponents/Card/Card";
import CardHeader from "../../../StyledComponents/Card/CardHeader";
import CardText from "../../../StyledComponents/Card/CardText";
import CardBody from "../../../StyledComponents/Card/CardBody";
import getParameterByName from "../../../Functions/functions";
import { ArrowBack } from "@material-ui/icons";
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment";
import GL_Table from "../NewInvoice/Tables/GL_Table";
import UsersByRole from "../NewInvoice/Dropdowns/UsersByRole";
import downloadAttachments from "../../../Functions/downloadAttachments";
import { getUserRoles } from "../../Home/actions";
import WarningBox from "../Components/WarningBox";
import CustomSnackbar from "../../../CustomSnackbar";
import TaxTable_Short from "../NewInvoice/Tables/Tax_Table_Short";
import ExpenseTable from "../NewInvoice/Tables/ExpenseTable";
import ConfirmationModal from "../../../components/ConfirmModal/ConfirmationModal";
import Heading from "../../../StyledComponents/Heading/Heading";
import "../../../css/formStyle.css";
import CommentHistory from "../NewInvoice/Tables/CommentHistory";
import POAlertDialog from "../NewInvoice/Tables/PoTableAlert";
import jwt from "jsonwebtoken";
import Spinner from "../../Spinner/Spinnerv2";
import SearchUsersRole from "../NewInvoice/Dropdowns/SearchUserRole";
import GL_Table_V2 from "../NewInvoice/Tables/GL_Table_V2";
import PageNotFound from "../NewInvoice/PageNotFound";
import CloseIcon from "@material-ui/icons/Close";
import DepartmentCoordinatorRent from "./DepartmentCoordinatorRent";
import RTBLineItems_Table from "../NewInvoice/Tables/RTBLineItems_Table";

const useStyles = makeStyles(dashboardStyle);
const Department = () => {
  const [filteredUserData, setFilteredUserData] = useState([]);
  const navigate = useNavigate();
  const invoiceId = getParameterByName("invoiceId");
  const roleId = getParameterByName("roleId");
  const roleName = getParameterByName("roleName");
  const vendorCode = getParameterByName("vendorCode");
  const invoiceStatus = getParameterByName("status");
  const location = useLocation();
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (location?.state?.msg) {
        setSuccessMessage(location?.state?.msg);
        // navigate(location.pathname, { replace: true })
        navigate(
          {
            pathname: location.pathname,
            search: location.search,
          },
          { replace: true }
        );
      }
    }, 2000);
    return () => clearTimeout(timeoutId);
  }, []);
  const invoicePayload = {
    Invoice_id: invoiceId,
    Vendor_Code: vendorCode,
  };
  const role = {
    roleId: roleId,
    roleName: roleName,
  };
  const [openInvalidWarningDate, setOpenInvalidWarningDate] = useState(false);
  const [attachmentURL, setAttachmentURL] = useState("");
  const [attachmentURLList, setAttachmentURLList] = useState([]);
  const [poBasedState, setPoBasedState] = useState("Non-PO");
  const [physicalOrEInvoice, setPhysicalOrEInvoice] = useState("Physical");
  const [rolesLoading, setRolesLoading] = useState(false);
  const [roles, setRoles] = useState([]);
  const [attachInvoiceLoading, setAttachInvoiceLoading] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const [statusForPayload, setStatusForPayload] = useState("");
  const [commentsList, setCommentsList] = useState([]);
  const [commentsLoading, setCommentsLoading] = useState(false);
const [rolesNavigate, setRolesNavigate] = useState([]);
 const [openProceedBtn, setOpenProceedBtn] = useState(false);
  const [reviwerFlag, setReviwerFlag] = useState(false);
  const [selectedRole, setSelectedRole] = useState(
    role ? { roleName: role?.roleName } : ""
  );
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const invoice_attachmentRef = useRef(null);
  const [attachError, setAttachError] = useState("");
  const [alertMessage, setAlertMessage] = useState(false);
  const [specialCharError, setSpecialCharError] = useState(false);
  const [loamApprover, setLoamApprover] = useState(false);
  const additionalAttachmentRef = useRef(null);
  const token = localStorage.getItem("user_token");
  const user = jwt.decode(token);
  const [allowToProceed, setAllowToProceed] = useState(true);
  const [pageLoader, setPageLoader] = useState(false);


  const [isParallel, setIsParallel] = useState(invoiceStatus == 'SendToDeptCoordinator' ? "Sequential" : "Parallel")

  useEffect(() => {
    if (invoicePayload.Invoice_id) {
      getMethodForPageRefresh(
        invoicePayload.Invoice_id,
        invoiceStatus,
        setAllowToProceed,
        setPageLoader
      );
    }
  }, [invoicePayload.Invoice_id, invoiceStatus]);
  const [formState, setFormState] = useState({
    delv_Note_No: "",
    courier_Company: "",
    courier_Tracking_No: "",
    created_On: new Date(),
    updated_By: "",
    invoice_Accounts_list: [],
    updated_On: new Date(),
    comments: "",
    aditional_Comments: "",
    po_Date: new Date().toString(),
    plant_Code: "",
    file_name: "",
    quantity: "",
    charge_Account: "",
    cost_Center: "",
    asset_No: "",
    dept_coordinator: "",
    loam_approver: "",
    buyer: "",
    prInitiator: "",
    taxTeam: "",
    paymentTerm: "",
    invoiceDocURL: "",
    isSubmittedByVendor: true,
    supervisorLevel: "",
    sodReviewer: "",
    dcReviewer: "",
    loamReviewer: [],
    supervisorReviewer: "",
    logisticsTeam: "",
    logisticsReviewer: "",
    reviewer1: "",
    reviewer2: "",
    pcdvSegment: "",
    pcdvLocation: "",
    invoiceLocation: "",
    employeeCode: "",
    vP_InvoiceId: 0,
    taxCard_List: [],
    isInitiator: false,
    isDeptCordinator: false,
    isHR: false,
    isPCDV: false, // EFDV initiator
    isPSID: false,
    isVPPayment: false,
    isVFPayment: false,
    isSubmittedByVendor: false,
    isImport: false,
    isLogistics: false,
    submission_Date: new Date(),
    // submission_Date: moment().format("YYYY-MM-DD"),
    pO_Based: true,
    pcdvLocation: "",
    pcdvSegment: "",

    psid: "",
    urgent: false,
    skipTaxStep: false,

    cnic: "",

    ntn: "",
    salesTaxCode: "",
    salesTaxAmount: "",
    calculateTax: true,
    eInvoice: true,

    cheque_No: "",
    invoice_Date: "",
    invoice_Id: invoicePayload?.Invoice_id,
    grn_No: "",
    pO_No: "",
    barcode_No: "",
    demandType: "",
    invoice_Type: "",
    invoice_No: "",
    invoiceCategory: "",
    invoice_Desc: "",
    invoice_Amount: 0,
    final_Invoice_Amount: "",
    dept_coordinator: "",
    irUser: "",
    ipUser: "",
    taxTeam: "",
    vendor_Code: "",
    vendor_Name: "",
    lineManager: "",
    directorHR: "",
    sharedServices: "",
    invoice_attachment: "",
    additionalDocIds: [], // paths
    due_Date: new Date(),
    provinceDuty : [],
    FCA_Details: [],
    Agreement_Details : [],
    stamp_Duty_Calculations : [],
    //   for import invoice (extra field)
    currency: "PKR",
    posting_Date: new Date(),
    document_Type: "",
    firstClearText: "",
    secondClearText: "",
    created_By: "",
    // rtbId : "",
    //  rtbLineItems_List : [],

    // vendor Detail
    vendor_Details: [],
    // =======import invoice some tables are below ==========
    additionalDocIds_array: [], // additional documents in array
attachment_Sr: [],
    // for Payment detail ("invoice_Payment" for po normal isInititor invoice).
    // ("invoice_Payment_Details" for import invoice) (will chnage).
    invoice_Payment: {
      inv_Payment_Id: 0,
      invoice_Id: 0,
      postingKey: "",
      sglInd: "",
      tType: "",
      paymentTerms: "",
      paymentDays: "",
      paymentMethod: "",
      paymentMethSupp: "",
      individualPayee: false,
      account: "",
      amount: 0,
      taxAmount: 0,
      dueOn: "",
      taxCode: "",
      description: "",
      order: "",
      costCenter: "",
      wbsElement: "",
      profitCenter: "",
      createdBy: "",
      createdDate: new Date(),
    },

    // Tax Table data (invoice_TaxDetails for po normal isInititor invoice)
    // ("invoice_Tax_Details" for import invoice) (will chnage).
    invoice_TaxDetails: [
      {
        taxId: 0,
        invoice_Id: 0,
        taxType: "",
        taxCode: "",
        amount: "",
        comments: "",
        created_By: "",
        created_On: new Date(),
        updated_By: "",
        updated_On: new Date(),
        taxCardId: 0,
      },
    ],

    // G/L Account detail. (actually for po_normal isInitiator)
    // (will change it to "invoice_Accounts_Details" for import invoice before hit api)
    invoice_Accounts: [],

    // PO Table Detail
    // "pO_Details" this keyword is used acctualy on backend, before hit the api it changes
    invoicePORef_List: [
      // we use this keyword due to reuse the PODetail table component.
      // {
      //   poItem: "", //  item #
      //   poNumber: "", // poNumber
      //   refDoc: "", // GRN No
      //   quantity: "", // GRN quantity
      //   val_Loccur: "", // GRN amount
      //   invoicE_QTY: "", //  consumed quantity
      //   invoicE_VAL: 0, // consumed Amount
      //   inpuT_QTY: "", //  invoice QTY
      //   inpuT_VAL: "", //  Invoice amount
      //   currency: "", // currency
      // },
    ],
    provinceDuty : [],
    FCA_Details: [],
    Agreement_Details : [],
    stamp_Duty_Calculations : [],

    Expense_Accounts_list: [
      // Invoice_Accounts_list for back-end
      {
        expenseDate: "",
        description: "",
        amount: 0,
        glAccount: "",
        accountType: "",
        costCenter: "",
        fixedAsset: "",
        tType: "",
        profitCenter: "",
        costCenterOwner: "",
        costCenterOwnerName: "",
        horizonId: "",
        vendorCode: "",
        department: "",
      },
    ],
    verified: false,
  });

  const classes = useStyles();

  const [openWarningBox, setOpenWarningBox] = useState(false);

  const showAttachmentsHandler = (attachment_URL) => {
    setAttachmentURL(attachment_URL);
  };

  const showVendorAndPO_NumberForImport = () => {
    let show =
      selectedRole?.roleName === "Department Coordinator" ? true : false;
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Deposit"
    ) {
      show = false;
    }
    return show;
  };
  const [newFormState, setNewFormState] = useState({
    taxCard_List: [],
    isInitiator: false,
    isDeptCordinator: false,
    isHR: false,
    isPCDV: false, // EFDV initiator
    isVPPayment: false,
    invoice_Accounts_list: [],
    provinceDuty : [],
    FCA_Details: [],
    Agreement_Details : [],
    stamp_Duty_Calculations : [],
    isVFPayment: false,
    isSubmittedByVendor: false,
    courier_Tracking_No: "",
    isImport: false,
    isLogistics: false,
    submission_Date: moment().format("YYYY-MM-DD"),
    pO_Based: true,
    isPSID: false,
    psid: "",
    urgent: false,
    skipTaxStep: false,
    isReturn: false,
    isProceed: true,
    invoice_Id: invoicePayload?.Invoice_id,
    grn_No: "",
    pO_No: "",
    barcode_No: "",
    demandType: "",
    invoice_Type: "",
    invoice_No: "",
    invoiceCategory: "",
    invoice_Desc: "",
    invoice_Amount: "",
    final_Invoice_Amount: "",
    dept_coordinator: "",
    irUser: "",
    ipUser: "",
    taxTeam: "",
    vendor_Code: "",
    vendor_Name: "",
    invoice_Date: moment().format("YYYY-MM-DD"),
    lineManager: "",
    directorHR: "",
    sharedServices: "",
    invoice_attachment: "",
    additionalDocIds: "", // paths
    comments: "",
    aditional_Comments: "",
    //   for import invoice (extra field)
    currency: "",
    posting_Date: new Date(),
    document_Type: "",
    firstClearText: "",
    secondClearText: "",
    created_By: "",
    isDelete:false,

    stampDuty: 0,
    // vendor Detail
    vendor_Details: [],
    // =======import invoice some tables are below ==========

    additionalDocIds_array: [], // additional documents in array

    due_Date: "",

    cnic: "",
    ntn: "",
    salesTaxCode: "",
    salesTaxAmount: "",
    calculateTax: true,
    eInvoice: true,

    currency: "",
    loamReviewer: [],
    loam_approver: "",

    // for Payment detail
    invoice_Payment: {
      inv_Payment_Id: 0,
      invoice_Id: 0,
      postingKey: "",
      sglInd: "",
      tType: "",
      paymentTerms: "",
      paymentDays: "",
      paymentMethod: "",
      paymentMethSupp: "",
      individualPayee: false,
      account: "",
      amount: 0,
      taxAmount: 0,
      dueOn: "",
      taxCode: "",
      description: "",
      order: "",
      costCenter: "",
      wbsElement: "",
      profitCenter: "",
      createdBy: "",
      createdDate: new Date(),
    },

    // Tax Table
    invoice_TaxDetails: [
      {
        taxId: 0,
        invoice_Id: 0,
        taxType: "",
        taxCode: "",
        amount: "",
        comments: "",
        created_By: "",
        created_On: new Date(),
        updated_By: "",
        updated_On: new Date(),
        taxCardId: 0,
      },
    ],


    provinceDuty : [],
    FCA_Details: [],
    Agreement_Details : [],
    stamp_Duty_Calculations : [],
    // G/L Account detail.
    invoice_Accounts: [
      // {
      //   accountId: 0,
      //   invoice_Id: 0,
      //   glAccount: "",
      //   costCenter: "",
      //   accountType: "", // D/C (debit/ credit)
      //   amount: 0,
      //   costCenterOwner: "",
      //   stCode: "",
      //   order: "",
      //   profitCenter: "",
      //   wbsElement: "",
      //   created_By: "",
      //   created_On: new Date(),
      //   updated_By: "",
      //   updated_On: new Date(),
      //   fixedAsset: "",
      //   tType: "",
      //   description: "",
      //   expenseDate: "",
      //   horizonId: "",
      //   department: "",
      //   vendorCode: "",
      // },
    ],
    // PO Table Detail
    // "pO_Details" this keyword is used acctualy on backend, before hit the api it changes
    invoicePORef_List: [
      // we use this keyword due to reuse the PODetail table component.
      // {
      //   poItem: "", //  item #
      //   poNumber: "", // poNumber
      //   refDoc: "", // GRN No
      //   quantity: "", // GRN quantity
      //   val_Loccur: "", // GRN amount
      //   invoicE_QTY: "", //  consumed quantity
      //   invoicE_VAL: 0, // consumed Amount
      //   inpuT_QTY: "", //  invoice QTY
      //   inpuT_VAL: "", //  Invoice amount
      //   currency: "", // currency
      // },
    ],
    Expense_Accounts_list: [
      // Invoice_Accounts_list for back-end
      {
        expenseDate: "",
        description: "",
        amount: 0,
        glAccount: "",
        accountType: "",
        costCenter: "",
        fixedAsset: "",
        tType: "",
        profitCenter: "",
        costCenterOwner: "",
        costCenterOwnerName: "",
        horizonId: "",
        vendorCode: "",
        department: "",
      },
    ],
    verified: false,
  });

  let RequiredReviwer =
    !newFormState.isReturn &&
    newFormState?.loamReviewer?.length === 0 &&
    roleName !== "Reviewer" &&
    (((formState?.invoice_Type === "Material" ||
      formState?.invoice_Type === "Services") &&
      user?.Location === "1") ||
      formState?.invoice_Type === "Agreement Payment")
      ? true
      : false;
  const additionalUsers = [
    {
      UserID: "32cb8f5b-2251-4ae8-a6a2-f9422a4da9cb",
      PersonalNumber: "10010590",
      Name: "Muhammad Hammad Bhojani ",
      CareerLadder: "HGRL 17",
    },
    {
      UserID: "5f446097-03e8-4951-ad47-4389b5a14e4b",
      PersonalNumber: "10010454",
      Name: "Jawad Akhter ",
      CareerLadder: "HGRL 17",
    },
    {
      UserID: "6d1bfa3a-6cba-4239-860e-d7fdc3879988",
      PersonalNumber: "10010098",
      Name: "Iftikhar Ul Haq ",
      CareerLadder: "HGRL 16",
    },
    {
      UserID: "82b1bab5-028e-4dbc-aec5-230ac1cfa1e1",
      PersonalNumber: "10010821",
      Name: "Muhammad Asad Rafique ",
      CareerLadder: "HGRL 12",
    },
    {
      UserID: "",
      PersonalNumber: "10009675",
      Name: "Kumar Das ",
      CarrierLadder: "HGRL 15",
    },
    {
      UserID: "d32ca310-3e0b-4c6c-a288-12f5028541f8",
      PersonalNumber: "991455",
      Name: "Daniyal Shakeel ",
      CarrierLadder: "",
    },
  ];
  const [loamUser, setLoamUser] = useState([]);
  const [loamLoading, setLoamLoading] = useState(false);
  const [invoicedelete, setInvoiceDelete] = useState("");
  const [deleteLoader, setdeleteLoader] = useState(false);
  const [warningFlag, setWarningFlag] = useState(false);
  const [multipleData, setMultipleData] = useState({
    sglInd: [],
    tType: [],
    glAccount: [],
    postingKey: [],
    paymentDetail: [],
    paymentMethod: [],
    paymentTerms: [],
    paymentMethSupp: [],
    poData: [],
    vendorTaxDetail: [],
    currency: [],
    invoice_Type: [],
  });
  const [userData, setUserData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [docError, setDocError] = useState("");
  const [invoiceLoading, setInvoiceLoading] = useState(false);
  const [SelectedReviewerList, setSelectedReviewerList] = useState([]);
  const [dragfile, setDragFile] = useState(false);
  const [dragloader, setDragLoader] = useState(false);
  const [CeoCostCenter, setCeoCostCenter] = useState(false);
  const [higherLoamApprover, sethigherLoamApprover] = useState(false);
  const getRefrenceDataCostCenter = async (refKey) => {
    const data = {
      refKey,
    };
    await axios({
      method: "get", //you can set what request you want to be
      url: `${process.env.REACT_APP_API_URL}/api/Invoices/GetRefrenceDatList_v1`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
        "Content-Type": "application/json",
      },
      params: data,
    })
      .then(async (res) => {
        setCeoCostCenter(res.data);
      })
      .catch((err) => {});
  };
  useEffect(() => {
    getRefrenceDataCostCenter("CeoCostCenter");
  }, []);

  const highest_amount = 0;
  const getLoamApprover = async () => {
    setLoamLoading(true);
    if (formState?.invoice_Type) {
      var invParam = [];
      newFormState?.invoice_Accounts_list.forEach(function (item, i) {
        if (item.amount) {
          var _cc =
            item.costCenter == undefined || item.costCenter == ""
              ? ""
              : item.costCenter;
          if (_cc != "")
            _cc =
              _cc.split("-").length > 0
                ? item?.costCenter?.split("-")[0].trim()
                : "";
          var _inv = invParam.filter((i) => i.cost_center == _cc);
          if (_inv.length > 0) {
            _inv[0].invoice_amount =
              parseFloat(_inv[0].invoice_amount) + parseFloat(item.amount);
          } else {
            invParam.push({
              invoice_amount: item.amount?.toString(),
              cost_center: _cc,
              invoice_type: formState?.invoice_Type || "",
              personal_number: user?.personal_number
                ? user?.personal_number
                : "",
            });
          }
        }
      });
      var _invParam = [];
      invParam.forEach(function (item, i) {
        if (parseFloat(item.invoice_amount) >= parseFloat(highest_amount)) {
          // app.highest_amount = item.invoice_amount;
          _invParam.push({
            invoice_amount: item.invoice_amount?.toString(),
            cost_center: item.cost_center.trim(),
            invoice_type: item.invoice_type,
            personal_number: user?.personal_number ? user?.personal_number : "",
          });
        }
      });
      // let payload = [];
      // if (
      //   formState?.invoice_Type &&
      //   newFormState?.invoice_Accounts_list?.length === 0
      // ) {
      //   payload.push({
      //     invoice_type: formState?.invoice_Type || "",
      //     cost_center: "",
      //     invoice_amount: formState.invoice_Amount
      //       ? formState.invoice_Amount?.toString()
      //       : "0",
      //     personal_number: user?.personal_number ? user?.personal_number : "",
      //   });
      // } else {
      //   payload.push(
      //     ...newFormState?.invoice_Accounts_list.map((item) => ({
      //       invoice_type: formState?.invoice_Type || "",
      //       // cost_center: item?.costCenter?.CostCenterCode || "",
      //       cost_center: item?.costCenter || "",
      //       invoice_amount: formState.invoice_Amount
      //         ? formState.invoice_Amount?.toString()
      //         : "0",
      //       personal_number: user?.personal_number ? user?.personal_number : "",
      //     }))
      //   );
      // }

      await axios({
        method: "post", //you can set what request you want to be
        url: `${process.env.REACT_APP_API_URL}/api/Invoices/GetApprovers`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          "Content-Type": "application/json",
        },
        data: _invParam,
        // data: payload,
      })
        .then(async (res) => {
          if (res?.data[0]?.Error) {
            // Handle the case when the API response contains an error message
            console.error(res.data[0].Error);

            // setLoamUser(additionalUsers);
            setLoamUser([]);
          } else if (res?.data && res?.data?.length > 0) {
            if (
              CeoCostCenter.length > 0 &&
              CeoCostCenter[0].ReferenceText !== ""
            ) {
              let _b = false;
              CeoCostCenter[0].ReferenceText.split(",").forEach((reference) => {
                if (!_b) {
                  _b =
                    newFormState?.invoice_Accounts_list?.filter(
                      (i) => i.costCenter == reference
                    ).length > 0;
                }
              });

              if (
                !_b &&
                res?.data.filter((i) => i?.CareerLadder === "HGRL 24").length >
                  0
              ) {
                res?.data.splice(res?.data?.length - 1, 1);
              }
              // Set the filtered data to loamApprovers state
            }
            // const combinedUsers = [...res.data, ...additionalUsers];
            const combinedUsers = res.data; // for production build
            // Combine the API response data with the additional list of users
            const uniqueUsersMap = {};

            //  filter out duplicates
            combinedUsers.forEach((user) => {
              const key = `${user?.CareerLadder}-${user?.Name}`;
              uniqueUsersMap[key] = user;
            });

            // Extract unique users from the map and convert them back to an array
            const uniqueUsers = Object.values(uniqueUsersMap);

            setLoamUser(uniqueUsers);
          }

          setLoamLoading(false);
        })
        .catch((err) => {
          setLoamLoading(false);
        });
    }
  };

  const getLoamApproverForEFDV = async () => {
    setLoamLoading(true);

    let payload = [];

    // payload.push({
    //   invoice_type: formState?.pcdvSegment || "",
    //   cost_center: "",
    //   invoice_amount: formState.invoice_Amount
    //     ? formState.invoice_Amount?.toString()
    //     : "0",
    //   personal_number: user?.personal_number ? user?.personal_number : "",
    // });
    payload.push(
      ...newFormState?.invoice_Accounts_list.map((item) => ({
        invoice_type: formState?.pcdvSegment || "",
        cost_center: item?.costCenter?.split("-")[0].trim() || "",
        invoice_amount: formState.invoice_Amount
          ? formState.invoice_Amount?.toString()
          : "0",
        personal_number: user?.personal_number ? user?.personal_number : "",
      }))
    );

    await axios({
      method: "post", //you can set what request you want to be
      url: `${process.env.REACT_APP_API_URL}/api/Invoices/GetApprovers`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
        "Content-Type": "application/json",
      },
      // data: formState,
      data: payload,
    })
      .then(async (res) => {
        if (res?.data[0]?.Error) {
          // Handle the case when the API response contains an error message
          console.error(res.data[0].Error);

          // setLoamUser(additionalUsers);
          setLoamUser([]);
        } else if (res?.data && res?.data?.length > 0) {
          // const combinedUsers = [...res.data, ...additionalUsers];
          const combinedUsers = res.data; // for production build
          // Combine the API response data with the additional list of users
          const uniqueUsersMap = {};

          //  filter out duplicates
          combinedUsers.forEach((user) => {
            const key = `${user?.CareerLadder}-${user?.Name}`;
            uniqueUsersMap[key] = user;
          });

          // Extract unique users from the map and convert them back to an array
          const uniqueUsers = Object.values(uniqueUsersMap);

          setLoamUser(uniqueUsers);
        }

        setLoamLoading(false);
      })
      .catch((err) => {
        setLoamLoading(false);
      });
  };

 const getLoamApproverForDistributor = async () => {
      setLoamLoading(true);
      const match = multipleData.loamApprover?.find(
        segment => segment?.ReferenceProp2 === "Director Sales"
    );

      await axios({
        method: "get", //you can set what request you want to be
        url: `${process.env.REACT_APP_API_URL}/api/Invoices/GetEmployeeList_v1/${match?.ReferenceCode}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          "Content-Type": "application/json",
        },
        
      })
        .then(async (res) => {
          if (res?.data[0]?.Error) {
            // Handle the case when the API response contains an error message
            console.error(res.data[0].Error);
  
            // setLoamUser(additionalUsers);
            setLoamUser([]);
          } else if (res?.data && res?.data?.length > 0) {
            // const combinedUsers = [...res.data, ...additionalUsers];
            const combinedUsers = res.data; // for production build

            // Combine the API response data with the additional list of users
            const uniqueUsersMap = {};
  
            //  filter out duplicates
           combinedUsers.forEach((user) => {
  const key = `${user?.employeeCode || user?.PersonalNumber}-${user?.employeeName || user?.Name}`;
  uniqueUsersMap[key] = {
    UserID: user?.id || user?.UserID || "",
    PersonalNumber: user?.employeeCode || user?.PersonalNumber || "",
    Name: user?.employeeName || user?.Name || "",
    CarrierLadder: user?.carrierLadder || user?.CarrierLadder || ""
  };
});
            // Extract unique users from the map and convert them back to an array
            const uniqueUsers = Object.values(uniqueUsersMap);
  
            setLoamUser(uniqueUsers);
          }
  
          setLoamLoading(false);
        })
        .catch((err) => {
          setLoamLoading(false);
        });
    };

  const deleteAttachmentFunc = () => {
    const data = {
      Id: invoicedelete?.id,
    };
    setdeleteLoader(true);
    var axios = require("axios");
    var config = {
      method: "delete",
      url: `${process.env.REACT_APP_API_URL}/api/UploadFile/DeleteAttachment`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      },
      params: data,
    };

    axios(config)
      .then(function (response) {
        const final = attachmentURLList?.filter(
          (x) => x?.path !== invoicedelete?.path
        );
        const files = newFormState.additionalDocIds.filter(
          (x, i) => x.path !== invoicedelete?.path
        );
        setAttachmentURLList(final);

        setNewFormState((formState) => ({
          ...formState,
          additionalDocIds: files,
        }));

        setdeleteLoader(false);
        setWarningFlag(false);

        setSuccessMessage(response.data);
      })
      .catch(function (error) {
        setErrorMessage(error.response.data);
      });
  };

  useEffect(() => {
    if (formState?.isPCDV && formState?.pcdvSegment) {
      getLoamApproverForEFDV();
    }else if(formState?.invoice_Type === "Final Settlement - Distributor"){
      getLoamApproverForDistributor()
    } else {
      getLoamApprover();
    }
  }, [
    newFormState?.invoice_Accounts_list,
    formState?.invoice_Type,
    formState?.pcdvSegment,
  ]);

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const getUsers = async () => {
    setLoading(true);
    console.log("kk")
    getUsersByRole("Reviewer", setUserData, setLoading);
  };
const matchingUser = loamUser?.find(u => u?.UserID === newFormState?.loam_approver);

const loamcareerLadder = matchingUser ? matchingUser?.CareerLadder||matchingUser?.CarrierLadder : null;
  
const changeHandler = (e) => {
  const { name, value } = e.target;
  // Apply formatting logic ONLY for invoice_Amount
  const rawValue =
    name === "invoice_Amount"
      ? value.replace(/,/g, '').replace(/[^\d.]/g, '')
      : value;

  // Always update newFormState
  setNewFormState((prev) => ({
    ...prev,
    [name]: rawValue,
  }));

  // Conditionally update formState as well
  if (
    selectedRole?.roleName === "Department Coordinator" &&
    formState?.isDeptCordinator
  ) {
    setFormState((prev) => ({
      ...prev,
      [name]: rawValue,
    }));
  }

  // Only call getVendorByPO for newFormState
  if (name === "pO_No") {
    getVendorByPO(rawValue, "vendor_Code", setNewFormState);
  }
};
  const LoamUserHandler = (newValue) => {
    const hasLowerCareerLadder = loamUser?.some((user) => {
      const selectedCareerLadder = parseInt(
        (newValue?.CareerLadder || newValue?.CarrierLadder)?.replace(/\D/g, ""),
        10
      );
      const userCareerLadder = parseInt(
        (user?.CareerLadder || user?.CarrierLadder)?.replace(/\D/g, ""),
        10
      );
      return userCareerLadder < selectedCareerLadder;
    });
    if (hasLowerCareerLadder) {
      sethigherLoamApprover(true);
    }
    if (!newValue) {
      setNewFormState({
        ...newFormState,
        loam_approver: "",
      });
    } else {
      setNewFormState({
        ...newFormState,
        loam_approver: newValue?.UserID ? newValue?.UserID : newValue?.Name,
      });
    }

    if (newValue?.UserID === "" || newValue?.UserID === "null") {
      setLoamApprover(true);
    } else {
      setLoamApprover(false);
      setErrorMessage("");
    }
  };

  const validateSpecialCharacters = (text) => {
    return /[!@#$%^&*()_+={}\[\]:;"'<>,?/~\\-`]/.test(text);
  };

  useEffect(() => {
    localStorage.setItem(
      "invoiceAccountsList",
      JSON.stringify(newFormState?.invoice_Accounts_list)
    );
  }, [newFormState?.invoice_Accounts_list]);
  // const confirmHandler = (e) => {
  //   e.preventDefault();
  //   let isError = false;
  //   let errorRows = [];
  //   if (!reviwerFlag) {
  //     if (
  //       !newFormState?.invoice_Accounts_list ||
  //       newFormState?.invoice_Accounts_list.length === 0
  //     ) {
  //       isError = true;
  //     } else {
  //       for (
  //         let index = 0;
  //         index < newFormState?.invoice_Accounts_list?.length;
  //         index++
  //       ) {
  //         const item = newFormState?.invoice_Accounts_list?.[index];
  //         if(!item?.glAccount && (!item?.amount || item?.amount === 0 )){
  //           isError = false;

  //         }else if (!item?.glAccount && (item?.amount || item?.amount === 0 )){
  //           isError = true;
  //           errorRows.push(index + 1);
  //         }else if (item?.glAccount && (!item?.amount || item?.amount === 0 )){
  //           isError = true;
  //           errorRows.push(index + 1);
  //         }else if (item?.profitCenter && (!item?.amount || item?.amount === 0 || !item?.glAccount)){
  //           isError = true;
  //           errorRows.push(index + 1);
  //         }
  //        else if (item?.glAccount && (item?.amount || item?.amount === 0)) {
  //           if (
  //             // !item?.stCode ||
  //             (!(item?.costCenter || item?.profitCenter))
  //             // !item?.description
  //           ) {
  //             isError = true;
  //             errorRows.push(index + 1);
  //           }
  //         }

  //       }
  //     }
  //   }
  //   // if (!reviwerFlag) {
  //   //   if (!newFormState?.invoice_Accounts_list || newFormState?.invoice_Accounts_list.length === 0) {
  //   //           isError = true;
  //   //       } else{
  //   //         for (
  //   //           let index = 0;
  //   //           index < newFormState?.invoice_Accounts_list?.length;
  //   //           index++
  //   //         ) {
  //   //           const item = newFormState?.invoice_Accounts_list?.[index];
  //   //           if (item?.glAccount && item?.amount) {
  //   //             if (
  //   //               // !item?.stCode ||
  //   //               !(item?.costCenter || item?.profitCenter) ||
  //   //               !item?.description
  //   //             ) {
  //   //               isError = true;
  //   //             }
  //   //           }
  //   //         }

  //   //       }

  //   // }

  //   const ContainsSpecialChars = newFormState?.invoice_Accounts_list?.some(
  //     (item) => validateSpecialCharacters(item.description)
  //   );
  //   if (newFormState?.isReturn) {
  //     setConfirmationModal(true);
  //     setErrorMessage("");
  //   } else {
  //     if (!isError) {
  //       if (ContainsSpecialChars) {
  //         setSpecialCharError(true);
  //       } else {
  //         if (balance !== 0)
  //         {
  //           setErrorMessage("Balance should be Zero");

  //         }
  //         else if (loamApprover) {
  //           setErrorMessage("Loam Approver user configuration is missing");

  //         }else if (!loamApprover) {

  //             setSpecialCharError(false);
  //             setOpenWarningBox(true);
  //             setErrorMessage("");

  //         }

  //         // Continue with form submission logic here
  //       }
  //     } else {
  //       const errorRowsString = errorRows.join(', ');
  //       setErrorMessage(`Please Fill GL Account Entry at row ${errorRowsString}.`);
  //     }

  //     // setOpenWarningBox(true);
  //   }
  // };
  const getOptionDisabled = (option) => {
    // Return true to disable the item based on a condition (e.g., if it's in the SelectedReviewerList)
    return SelectedReviewerList.includes(option.userId);
  };
  let ReviewerMandatory = multipleData?.invoice_Type.filter((item) => {
    return item.ReferenceCode == newFormState?.invoice_Type;
  });


  // ✅ Shared validation helpers
const fcaTableValidation = (FCA_Details, selectedRole, showGLTable) => {

  console.log("FCA_Details in drl", FCA_Details);
  let errorRows = [];
  if (
    selectedRole?.roleName === "Department Coordinator" &&
    showGLTable === "Rent" &&
    (!Array.isArray(FCA_Details) || FCA_Details.length === 0)
  ) {
    return [{ index: 0, missingFields: ["Payment Details Missing"] }];
  }

  FCA_Details?.forEach((item, index) => {
    let missingFields = [];
    if (!item?.lastRent && !item?.LastRent) missingFields.push("Last Rent");
    if (!item?.newRent && !item?.NewRent) missingFields.push("New Rent");
    if (!item?.from && !item?.From) missingFields.push("From");
    if (!item?.to && !item?.To) missingFields.push("To");
    if (!item?.period && !item?.Period) missingFields.push("Period");

    if (missingFields.length > 0) {
      errorRows.push({ index: index + 1, missingFields });
    }
  });
  return errorRows;
};

  const agreementTableValidation = (Agreement_Details, selectedRole, showGLTable) => {
    let errorRows = [];
    if (
      (selectedRole?.roleName === "Department Coordinator" && showGLTable?.showForRENT) &&
      (!Array.isArray(Agreement_Details) || Agreement_Details?.length === 0)
    ) {
      setErrorMessage("Please Fill Agreement  Details.");
      return errorRows;
    }

    const anyRowHasDates = Agreement_Details?.some(
      (item) =>
        (item.agreementStartDate !== undefined && item.agreementStartDate !== '') ||
        (item.agreementEndDate !== undefined && item.agreementEndDate !== '')
    );

    Agreement_Details?.forEach((item, index) => {
      const hasStart = item.agreementStartDate !== undefined && item.agreementStartDate !== '';
      const hasEnd = item.agreementEndDate !== undefined && item.agreementEndDate !== '';
      const missingFields = [];

      if (!anyRowHasDates && index === 0) {
        missingFields.push("Agreement Start Date");
        missingFields.push("Agreement End Date");
      } else {
        if (hasStart && !hasEnd) missingFields.push("Agreement End Date");
        if (hasEnd && !hasStart) missingFields.push("Agreement Start Date");

        if (hasStart && hasEnd && (!item.tenure || item.tenure === 0)) {
          missingFields.push("Tenure");
        }
      }

      if (missingFields.length > 0) {
        errorRows.push({ index: index + 1, missingFields });
      }
    });

    return errorRows;
  };

  const confirmHandler = (e) => {
    e.preventDefault();


    const fcaErrors = fcaTableValidation(formState?.FCA_Details, selectedRole, formState?.invoice_Type);
  const agreementErrors = agreementTableValidation(formState?.Agreement_Details, selectedRole, formState?.invoice_Type);

  const totalMonths = formState?.stamp_Duty_Calculations?.reduce(
    (sum, row) => sum + (parseFloat(row.noOfMonths) || 0),
    0
  ) || 0;

  const tenure = parseFloat(formState?.Agreement_Details?.[0]?.tenure || 0);

  // ✅ Check for FCA validation
  if (fcaErrors?.length > 0 && selectedRole?.roleName === "Department Coordinator" &&
   formState?.invoice_Type === "Rent" ) {
    let errorMessage = `Please fill Payment Details:\n`;
    fcaErrors.forEach(({ index, missingFields }) => {
      errorMessage += `Row ${index}: ${missingFields.join(", ")}\n`;
    });
    setErrorMessage(errorMessage);
    return;
  }

  // ✅ Check for Agreement validation
  if (agreementErrors?.length > 0 &&  selectedRole?.roleName === "Department Coordinator" &&
   formState?.invoice_Type === "Rent" ) {
    let errorMessage = `Please fill Agreement Details:\n`;
    agreementErrors.forEach(({ index, missingFields }) => {
      errorMessage += `Row ${index}: ${missingFields.join(", ")}\n`;
    });
    setErrorMessage(errorMessage);
    return;
  }

  // ✅ Check Stamp Duty tenure vs months
    // const ReviewerMandatory= multipleData?.invoice_Type
    // .filter((item) => {return item.ReferenceCode==newFormState?.invoice_Type})
    if (
      ((newFormState?.loamReviewer == undefined ||
        newFormState?.loamReviewer == "" ||
        newFormState?.loamReviewer.length==0) &&
      ReviewerMandatory[0]?.EmployeeGrade !== "" &&
      (loamcareerLadder?.split(" ")[1]==ReviewerMandatory[0]?.EmployeeGrade ||
      loamcareerLadder?.split(" ")[1]>ReviewerMandatory[0]?.EmployeeGrade ) &&
      selectedRole?.roleName === "Department Coordinator"
    ) && !newFormState.isReturn && !newFormState.isDelete) {
      setConfirmationModal(false);
      setErrorMessage("Please Select Reviewer");
    } else {
      let isError = false;
      let errorRows = [];
      if (!reviwerFlag && !formState?.isPCDV) {
        if (
          !newFormState?.invoice_Accounts_list ||
          newFormState?.invoice_Accounts_list.length === 0
        ) {
          isError = true;
          setErrorMessage("Please Fill GL Entry.");
        } else {
          for (
            let index = 0;
            index < newFormState?.invoice_Accounts_list?.length;
            index++
          ) {
            const item = newFormState?.invoice_Accounts_list?.[index];
            let missingFields = [];

            if (!item?.glAccount?.split("-")[0])
              missingFields.push("GL Account");
            if (item?.amount === undefined || item?.amount === 0)
              missingFields.push("Amount");
            if (!item?.costCenter?.split("-")[0] && !item?.profitCenter)
              missingFields.push("Cost Center or Profit Center");
            if (item?.costCenter?.split("-")[0] && !item?.costCenterOwnerName)
              missingFields.push("costCenterOwnerName");
            if (missingFields.length > 0) {
              isError = true;
              errorRows.push({ index: index + 1, missingFields });
            }
          }
        }
      }
      const ContainsSpecialChars = newFormState?.invoice_Accounts_list?.some(
        (item) => validateSpecialCharacters(item.description)
      );
      if (newFormState?.isReturn) {
        setConfirmationModal(true);
        setErrorMessage("");
      } else if (newFormState?.isDelete) {
        setOpenWarningBox(true);
        setErrorMessage("");
      } else {
        if (!isError) {
          if (ContainsSpecialChars) {
            setSpecialCharError(true);
          } else {
            if (
              balance !== 0 &&
              !formState.isImport &&
              !formState?.isPCDV &&
              invoiceStatus !== "SendToReviewerFromIR" &&
              invoiceStatus !== "SendToReviewerFromIP" &&
              invoiceStatus !== "SendToReviewerFromSupervisor" &&
              invoiceStatus !== "SendToReviewerFromManager" &&
              invoiceStatus !== "SendToReviewerFromGM"
            ) {
              setErrorMessage("Balance should be Zero");
            } else if (
              loamApprover &&
              invoiceStatus !== "SendToReviewerFromIR"
            ) {
              setErrorMessage("Loam Approver user configuration is missing");
            } else if (
              !loamApprover ||
              invoiceStatus == "SendToReviewerFromIR"
            ) {
              setSpecialCharError(false);
              setOpenWarningBox(true);
              setErrorMessage("");
            }

            // Continue with form submission logic here
          }
        } else {
          let errorMessage = `Please fill GL Entry required fields and ensure Amount is not zero:\n`;
          errorRows.forEach(({ index, missingFields }) => {
            errorMessage += `Row ${index}: ${missingFields.join(", ")}\n`;
          });

          setErrorMessage(errorMessage);
        }

        // setOpenWarningBox(true);
      }
    }
  };
  const showVendorCodeForImport = () => {
    let show =
      selectedRole?.roleName === "Department Coordinator" ? true : false;
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Spare Parts"
    ) {
      show = false;
    }
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Material"
    ) {
      show = false;
    }
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Samples"
    ) {
      show = false;
    }
    return show;
  };
  const [Post, setPost] = useState(true);
  const submitHandler = () => {
    if (newFormState?.isReturn || newFormState.isDelete) {
      changeInvoiceStatus(
        formState.invoice_Id,
        statusForPayload,
        setConfirmationModal,
        setAttachInvoiceLoading,
        setSuccessMessage,
        setErrorMessage,
        navigate,
        newFormState.comments,
        newFormState.aditional_Comments,
        setPost
      );
      setOpenWarningBox(false);
      setConfirmationModal(false);
    } else {
      let updatedPyaload ;
      if(typeof newFormState?.loamReviewer === "string"){
         updatedPyaload  = {... newFormState , loamReviewer : newFormState?.loamReviewer?.split(" ")}
      }
      else {
        updatedPyaload = {...newFormState}
      }
      let parallel  ;

      console.log(roleName, "roleName")
      if(roleName === "Reviewer"){
        if(newFormState?.isReject){
          if(isParallel == "Sequential"){
            parallel = false
           }
           if(isParallel == "Parallel"){
             parallel = true
           }
         }
         else {
          parallel = true
         }
      }

      else if(roleName === "Department Coordinator"){
 if(isParallel == "Sequential"){
            parallel = false
           }
           if(isParallel == "Parallel"){
             parallel = true
           }
      }

      console.log(parallel, "parallel")
      putDeptCoordinatorAndReviewerInvoice(
        updatedPyaload,
        setNewFormState,
        setErrorMessage,
        setSuccessMessage,
        setAttachInvoiceLoading,
        navigate,
        setOpenWarningBox,
        reviwerFlag,
        setPost,
        parallel
      );
      setOpenWarningBox(false);
    }
  };


  useEffect(()=>{
 if(!Post)  {

 if(formState.isDeptCordinator && (invoiceStatus === 'SendToDeptCoordinatorFromReviewer' || invoiceStatus ==='SendToDeptCoordinatorFromLoamApprover' || invoiceStatus === "SendToDeptCoordinatorFromIP")){
    let parallel  ;

      console.log(roleName, "roleName")
      if(roleName === "Reviewer"){
        if(newFormState?.isReject){
          if(isParallel == "Sequential"){
            parallel = false
           }
           if(isParallel == "Parallel"){
             parallel = true
           }
         }
         else {
          parallel = true
         }
      }

      else if(roleName === "Department Coordinator"){
 if(isParallel == "Sequential"){
            parallel = false
           }
           if(isParallel == "Parallel"){
             parallel = true
           }
      }
  const updatedFormState = {
               ...formState , 
               isParallel: parallel,
               isInitiator : false ,
               isDeptCordinator: (selectedRole?.roleName === "Department Coordinator" && (formState.invoice_Type=='DES' || formState.invoice_Type=='Rent'))?true:formState.isDeptCordinator,
               skipTaxStep:(selectedRole?.roleName === "Department Coordinator" && (formState.invoice_Type=='DES' || formState.invoice_Type=='Rent'))?true:formState.skipTaxStep,
               dept_coordinator:(selectedRole?.roleName === "Department Coordinator" && (formState.invoice_Type=='DES' || formState.invoice_Type=='Rent'))?user?.LoginId:formState.dept_coordinator,
                loamReviewer: [],
             }
       
              if(!(newFormState?.isDelete)){
                 createNewInvoice(
                 updatedFormState,
                 setFormState,
                 poBasedState,
                 setErrorMessage,
                 setSuccessMessage,
                 setAttachInvoiceLoading,
                 setOpenProceedBtn,
                 navigate,
                 rolesNavigate,
                 setPost
               );
              }
 }
 }
  },[Post])
  const roleHandler = (newValue) => {
    setFormState((formState) => ({
      ...formState,
      isInitiator: newValue.roleName === "I2P Initiator" ? true : false,
      isHR: newValue.roleName === "HR" ? true : false,
      isPCDV: newValue.roleName === "EFDV Initiator" ? true : false,
      isImport: newValue.roleName === "Import" ? true : false,
      isLogistics: newValue.roleName === "Logistic" ? true : false,
    }));

    setSelectedRole(newValue);
  };

  const handleDrag = function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragLoader(true);
    } else if (e.type === "dragleave") {
      setDragLoader(false);
      setDragFile(true);
    }
  };
  const handleDrop = function (e) {
    e.preventDefault();
    e.stopPropagation();
    setDragLoader(false);

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      uploadAdditioalDocumentFile(
        e,
        setNewFormState,
        setAttachInvoiceLoading,
        "additionalDocIds",
        additionalAttachmentRef,
        setDocError,
        setAttachError,
        setAlertMessage,
        invoicePayload,
        selectedRole,
        dragfile,
        setDragFile,
        setSuccessMessage
      );
    }
  };

  useEffect(() => {
    if (formState.invoice_Id) {
      if (formState.pO_Based) {
        setPoBasedState("PO");
      } else {
        setPoBasedState("Non-PO");
      }
    }
  }, [formState.pO_Based]);

  useEffect(() => {
    let filterd_data = [];
    if (formState?.additionalDocIds?.length > 0) {
      filterd_data = formState.additionalDocIds.filter((e) => Number(e) !== 0);
    }
    setAttachmentURLList((pre) => [
      formState?.invoice_attachment,
      ...filterd_data,
    ]);
    if (formState?.invoice_attachment) {
      setAttachmentURL(formState?.invoice_attachment);
    } else {
      setAttachmentURL(formState?.additionalDocIds[0]);
    }
  }, [formState?.invoice_attachment, formState?.additionalDocIds]);

  useEffect(() => {
    if (newFormState?.additionalDocIds?.length > 0) {
      setAttachmentURLList((pre) => [
        ...pre,
        newFormState?.additionalDocIds[
          newFormState?.additionalDocIds.length - 1
        ],
      ]);
    }
  }, [newFormState?.additionalDocIds]);

  useEffect(() => {
    if (formState?.invoice_No) {
      getUsers();
    }

    setNewFormState(formState);
    setNewFormState((newFormState) => ({
      ...newFormState,
      additionalDocIds: [],
    }));
  }, [formState, SelectedReviewerList]);

  const [costCenterList, setCostCenterList] = useState([]);
  const [costCenterLoading, setCostCenterLoading] = useState(false);

  // useEffect(()=>{
  //   if(commentsList[commentsList?.length - 1]
  //     ?.ActivityName == "IR" ){
  //       setNewFormState({
  //         ...newFormState,
  //         loamReviewer:[]
  //       })
  //     }
  // },[formState])
  useEffect(() => {
    getUserRoles(setRoles, setRolesLoading);
    getCostCenterData("", setCostCenterLoading, setCostCenterList, () => {});
    getRefrenceDataList(
      "invoiceType",
      "invoice_Type",
      () => {},
      setMultipleData
    );
    getRefrenceDataList(
          "LoamApprover", 
          "loamApprover",
          setFormState,
          setMultipleData
        )
    if (!formState?.isPCDV && formState?.invoice_No) {
      getRefrenceDataList(
        "invoiceType",
        "invoice_Type",
        () => {},
        setMultipleData
      );
    }

    if (invoicePayload && role) {
      vendorTaxDetailForCnic(setFormState, invoicePayload?.Vendor_Code);
      getInvoiceByInvoiceIdAndRoleId(invoicePayload, role, setFormState);
      getCommentsByInvoiceId(
        setCommentsList,
        setCommentsLoading,
        invoicePayload?.Invoice_id
      );
      // getInvoiceByInvoiceIdAndRoleId(
      //   setIsLoading,
      //   invoicePayload,
      //   role,
      //   setFormState
      // );

      // if (!formState.isImport) {
      if (roleName === "Reviewer") {
        getAllInvoiceDetailByInvoiceIdForDCReviewer(
          setFormState,
          setMultipleData,
          invoicePayload?.Invoice_id,
          () => {},
          () => {},
          "",
          setInvoiceLoading,
          setSelectedReviewerList ,
          setIsParallel
          
        );
      } else {
        getAllInvoiceDetailByInvoiceIdV2(
          setFormState,
          setMultipleData,
          invoicePayload?.Invoice_id,
          () => {},
          () => {},
          "",
          setInvoiceLoading , 
          setIsParallel
        );
      }

      // }
    }

    if (roleName === "Reviewer") {
      setReviwerFlag(true);
    }
  }, [roleName]);

  // const [vendor__Code, setVendor__Code] = useState("");
  // useEffect(() => {
  //   if (formState?.vendor_Code) {
  //     setVendor__Code(formState?.vendor_Code);
  //   } else {
  //     setFormState((formState) => ({
  //       ...formState,
  //       vendor_Code: vendor__Code,
  //     }));
  //   }
  // }, [formState.vendor_Code]);

  useEffect(() => {
    if (formState?.invoice_Accounts_list?.length > 0) {
      let temp = [];
      for (let i = 0; i < formState?.invoice_Accounts_list?.length; i++) {
        const item = formState?.invoice_Accounts_list[i];

        const obj = {
          accountId: 0,
          invoice_Id: Number(invoicePayload?.Invoice_id),
          expenseDate: item?.ExpenseDate,
          glAccount: item?.GLAccount,
          GLAccount: item?.GLAccount,
          // costCenter: { CostCenterCode: item?.CostCenter || "" },
          costCenter: item?.CostCenter,
          // costCenter:  matchingCostCenter[0],

          costCenterOwner: item?.CostCenterOwner,
          accountType: item?.AccountType,
          costCenterOwnerName: item?.CostCenterOwnerName,
          wbsElement: item?.WBSElement,
          horizonId: item?.HorizonId,
          vendorCode: item?.VendorCode,
          amount: Number(item?.Amount || 0),
          profitCenter: Number(item?.ProfitCenter || 0),
          department: item?.Department,
          description: item?.Description || "",
          tType: item?.TType || "",
          fixedAsset: item?.FixedAsset || "",
        };
        temp.push(obj);
      }
      if(commentsList[commentsList?.length - 1]
            ?.ActivityName == "IR" ){
              setNewFormState((formState) => ({
                ...formState,
                loamReviewer:[],
                invoice_Accounts_list: temp,
                Expense_Accounts_list: temp,
              }));
            }else{
              setNewFormState((formState) => ({
                ...formState,
                invoice_Accounts_list: temp,
                Expense_Accounts_list: temp,
              }));
            }
     
    }
  }, [formState, costCenterList]);
  const isContainEmailFormate = (fileExtension) => {
    const emailExtensions = [
      "eml",
      "msg",
      "pst",
      "mbox",
      "emlx",
      "dbx",
      "mbx",
      "nws",
      "p7m",
      "mht",
      "mhtml",
      "rar",
      "zip",
    ];
    return emailExtensions.includes(fileExtension.toLowerCase());
  };

  const calculateTotalGLAmount = () => {
    const totalGLAmount = newFormState.invoice_Accounts_list?.reduce(
      (accumulator, currentValue) => {
        const amountWithoutCommas = String(currentValue?.amount).replace(
          /,/g,
          ""
        );
        const numericAmount = Number(Number(amountWithoutCommas)?.toFixed(2));

        return accumulator + numericAmount;
        // return accumulator + Number(Number(currentValue.amount)?.toFixed(2));
      },
      0
    );
    return totalGLAmount;
  };

  // Function to calculate balance amount
  const calculateBalance = () => {
    const totalGLAmount = calculateTotalGLAmount();

    let balance = 0;
    if(formState?.invoice_Type=== 'Final Settlement - Distributor'){
        balance = Number(Number(formState?.invoice_Amount)?.toFixed(2)) +
      Number(Number(totalGLAmount)?.toFixed(2));
    }else{
     balance = Number(Number(formState?.invoice_Amount)?.toFixed(2)) -
      Number(Number(totalGLAmount)?.toFixed(2));
    }
    return balance;
  };

  // Usage
  const totalGLAmount = calculateTotalGLAmount();
  const balance = calculateBalance();

  useEffect(() => {
    const selectedUserIds = newFormState?.loamReviewer;
    console.log(selectedUserIds , "selectedUserIds")
    const newFilteredData = userData?.filter(
      (user) => !selectedUserIds?.includes(user?.userId)
    );
    setFilteredUserData(newFilteredData);
  }, [newFormState]);

  useEffect(() => {
    console.log(userData, "user data")
    setFilteredUserData(userData);
  }, [userData]);

  return (
    <>
      {/* {allowToProceed ? ( */}
        <Card
          onDragEnter={handleDrag}
          onDragLeave={handleDrag}
          onDragOver={handleDrag}
          onDrop={handleDrop}>
          <Backdrop
            sx={{
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={dragloader || pageLoader}></Backdrop>
          <CardHeader color="primary" text>
            <CardText
              style={{
                padding: "0px 20px",
                backgroundColor: "#031C30",
                color: "white",
              }}>
              <Grid container justifyContent="space-between">
                <Grid item xs={2} sm={3} md={3} lg={6}>
                  <h1 style={{ fontSize: "24px" }}>DRL Approval</h1>
                </Grid>
                <Grid item xs={6} sm={6} md={6} lg={6}>
                  <IconButton
                    variant="contained"
                    style={{ float: "right", marginTop: "1.5%" }}
                    onClick={() => navigate("/home")}>
                    <ArrowBack
                      style={{ color: "#fff" }}
                      titleAccess="Go Back"
                    />
                  </IconButton>
                </Grid>
              </Grid>
            </CardText>
          </CardHeader>
          <CardBody>
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={attachInvoiceLoading || invoiceLoading}>
              <Spinner />
            </Backdrop>

            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12} lg={6}>
                <Grid container style={{ marginTop: "1px" }}>
                  {/* Submitter role */}
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    style={{ marginTop: "8px" }}>
                    <Typography style={{ color: "black" }}>
                      Submitter Role:{" "}
                      <span className={classes.asterisk}>*</span>
                    </Typography>
                    <Autocomplete
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "30px",
                          textAlign: "center",
                          display: "flex",
                          alignItems: "center",
                        },
                        "& .MuiInputBase-input": {
                          marginTop: "-4px", // Adjust this value to move the text up
                          fontSize: 15,
                        },
                      }}
                      id="submitter_role"
                      options={roles}
                      size="small"
                      value={selectedRole}
                      getOptionLabel={(option) =>
                        (option !== "" && `${option?.roleName}`) || ""
                      }
                      loading={rolesLoading}
                      onChange={(event, newValue) => {
                        roleHandler(newValue);
                      }}
                      disabled
                      renderInput={(params) => (
                        <TextField {...params} type="text" name="" required />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={9} lg={9}></Grid>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  {!formState.isImport && !formState.isPCDV && (
                    <InvoiceCheckboxes
                      formState={formState}
                      setFormState={setFormState}
                      selectedRole="Department Coordinator"
                      disabled={true}
                    />
                  )}
                  {!formState.isImport && !formState.isPCDV && (
                    <InvoiceRadioButtons
                      formState={formState}
                      setFormState={setFormState}
                      selectedRole="Department Coordinator"
                      physicalOrEInvoice={physicalOrEInvoice}
                      poBasedState={poBasedState}
                      alignForAttachment={true}
                    />
                  )}
                  {formState?.isPCDV && (
                    <div style={{ marginTop: "30px" }}></div>
                  )}
                  <InvoiceTextField
                  formState={formState}
                    newFormState={formState}
                    setNewFormState={setFormState}
                    selectedRole="Department Coordinator"
                    disabled={(  (invoiceStatus === 'SendToDeptCoordinatorFromReviewer' && formState.isDeptCordinator) || (invoiceStatus==='SendToDeptCoordinatorFromLoamApprover' && formState.isDeptCordinator) ||  (invoiceStatus==='SendToDeptCoordinatorFromIP' && formState.isDeptCordinator)) ? false : true}                    poBasedState={poBasedState}
                    showVendorAndPO_NumberForImport={() => {}}
                    showVendorCodeForImport={showVendorCodeForImport}
                    invoice_attachmentRef={invoice_attachmentRef}
                    additionalAttachmentRef={additionalAttachmentRef}
                    setAttachInvoiceLoading={setAttachInvoiceLoading}
                    //   setAttchmentFile_UI={setAttchmentFile_UI}
                    //   attachmentFile_UI={attachmentFile_UI}
                    physicalOrEInvoice={physicalOrEInvoice}
                    changeHandler={changeHandler}
                    alignForAttachment={true}
                    setAttachmentURLList={setAttachmentURLList}
                    attachmentURLList={attachmentURLList}
                    setAttachmentURL={setAttachmentURL}
                    showAttachmentsHandler={showAttachmentsHandler}
                    setOpenInvalidWarningDate={setOpenInvalidWarningDate}
                    multipleData={multipleData}
                  />
                </Grid>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                style={{ paddingLeft: "7px", marginTop: "20px" }}>
                <Heading title="Attachment Preview">
                  <span>
                    {attachmentURL != ""
                      ? attachmentURL == formState?.invoice_attachment
                        ? " (Invoice Attachmnets)"
                        : "(Additional Documents)"
                      : null}
                  </span>
                </Heading>

                <AttachmentsCover
                  attachmentURLList={attachmentURLList}
                  setAttachmentURLList={setAttachmentURLList}
                  attachmentURL={attachmentURL}
                  setAttachmentURL={setAttachmentURL}
                />
              </Grid>
            </Grid>
            <form onSubmit={confirmHandler} style={{ marginTop: "50px" }}>
              {!formState.isImport &&
                !formState.skipTaxStep &&
                !formState?.isPCDV && (
                  <>
                    <Heading title="Tax" />
                    <TaxDetail
                      formState={newFormState}
                      setFormState={setNewFormState}
                      invoice_Amount={newFormState.invoice_Amount}
                      disabled={true}
                    />
                    {/* <TaxTable_Short */}
                    <TaxTable_Short
                      formState={newFormState}
                      setFormState={setNewFormState}
                      tempSetFormState={setFormState}
                      invoicePayload={invoicePayload}
                      disabled={true}
                      // invoiceTaxDetail_forImport_Inv={invoiceTaxDetail}
                      // setInvoiceTaxDetail_forImport_Inv={setInvoiceTaxDetail}
                    />
                    {/* <TaxTable
                formState={formState}
                setFormState={setFormState}
                invoice_Amount={formState.invoice_Amount}
                invoicePayload={invoicePayload}
                show={true}
              /> */}
                  </>
                )}
              <span></span>
              {formState?.isPCDV && (
                <Grid container style={{ marginTop: "5px" }}>
                  <Grid item xs={12} sm={12} md={6} lg={12}>
                    <ExpenseTable
                      formState={newFormState}
                      setFormState={setNewFormState}
                      editable={false}
                    />
                  </Grid>
                </Grid>
              )}
              {formState?.isPCDV && (invoiceStatus === "SendToReviewer2" ||
                invoiceStatus === "SendToReviewer2FromLoamApprover"
              )&& (
                <>
                  <Grid
                    container
                    spacing={1}
                    style={{ marginTop: "20px", padding: " 0px 5px " }}>
                    {/* Loam Approver */}
                    <Grid item xs={12} sm={12} md={3} lg={3}>
                      <Typography style={{ color: "black" }}>
                        <span className={classes.asterisk}>
                          {!newFormState?.isReturn ? "*" : ""}
                        </span>
                        Loam Approver:
                      </Typography>
                      <Autocomplete
                        size="small"
                        style={{ width: "100%" }}
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "30px",
                            textAlign: "center",
                            display: "flex",
                            alignItems: "center",
                          },
                          "& .MuiInputBase-input": {
                            marginTop: "-4px", // Adjust this value to move the text up
                            fontSize: 15,
                          },
                        }}
                        disabled={false}
                        value={
                          loamUser.find((user) =>
                            user?.UserID
                              ? user?.UserID === newFormState?.loam_approver
                              : user?.Name === newFormState?.loam_approver
                          ) || ""
                        }
                        onChange={(e, newValue) => {
                          LoamUserHandler(newValue);
                        }}
                        //   onChange={(e, newValue) => {
                        //     const hasLowerCareerLadder = loamUser.some((user) => {
                        //       const selectedCareerLadder = parseInt(newValue?.CareerLadder.replace(/\D/g, ''), 10);
                        //       const userCareerLadder = parseInt(user?.CareerLadder.replace(/\D/g, ''), 10);
                        //       console.log(selectedCareerLadder,"selectedCareerLadder")
                        //       console.log(userCareerLadder,"userCareerLadder")
                        //       return userCareerLadder < selectedCareerLadder;
                        //     });
                        //   console.log(hasLowerCareerLadder,"hasLowerCareerLadder")
                        //  if(hasLowerCareerLadder){
                        //   console.log("lower")
                        //  }
                        //     if (!newValue) {
                        //       setNewFormState({
                        //         ...newFormState,
                        //         loam_approver: "",
                        //       });
                        //     } else {
                        //       if (
                        //         newValue?.UserID === "" ||
                        //         newValue?.UserID === "null"

                        //       ) {
                        //         setLoamApprover(true);
                        //       } else {
                        //         setLoamApprover(false);
                        //         setErrorMessage("");
                        //       }
                        //       setNewFormState({
                        //         ...newFormState,
                        //         loam_approver: newValue?.UserID ?  newValue?.UserID :  newValue?.Name ,
                        //       });
                        //     }

                        //   }}
                        options={loamUser}
                        getOptionLabel={(option) =>
                          option
                            ? option?.PersonalNumber
                              ? `${option?.PersonalNumber} -` +
                                `${option?.Name}`
                              : `${option?.Name}`
                            : ""
                        }
                        loading={loamLoading}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            // variant="standard"
                            size="small"
                            // required
                            // InputProps={{
                            //   ...params.InputProps,
                            //   disableUnderline: true,
                            // }}
                            placeholder="Select loam Approver"
                            required={
                              newFormState?.isProceed && !newFormState?.isReturn
                            }
                          />
                        )}
                      />
                    </Grid>
                 
                    {/* <Grid item xs={12} sm={12} md={3} lg={3}>
             
                  <SearchUsersRole
                    label="Loam Approver"
                    apiString="Loam Approver"
                    name="loam_approver" // pending.
                    placeholder="Select a Loam Approver"
                    formState={newFormState}
                    setNewFormState={setNewFormState}
                    changeHandler={changeHandler}
                    required={newFormState?.isProceed}
                    disabled={false}
                    classes={classes}
                  />
                </Grid> */}

                    {/* IP user */}
                    <Grid item xs={12} sm={12} md={3} lg={3}>
                      {/* <FormControl fullWidth size="small">
                    <UsersByRole
                      label="IP User"
                      apiString="IP"
                      name="ipUser"
                      placehold="Select a User"
                      formState={newFormState}
                      changeHandler={changeHandler}
                      // required={true}
                      required={newFormState?.isProceed}
                      classes={classes}
                    />
                  </FormControl> */}
                    <SearchUsersRole
                        label="IP User"
                        apiString="IP"
                        name="ipUser" // pending.
                        placeholder="Select a User"
                        formState={newFormState}
                        setNewFormState={setNewFormState}
                        changeHandler={changeHandler}
                        required={newFormState?.isProceed}
                        disabled={false}
                        classes={classes}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={3}>
                          <Typography style={{ color: "black" }}>
                            {RequiredReviwer ? (
                              <span className={classes.asterisk}>*</span>
                            ) : null}
                            Add Reviewer:{" "}
                          </Typography>
                          <Autocomplete
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "30px",
                            textAlign: "center",
                            display: "flex",
                            alignItems: "center",
                          },
                          "& .MuiInputBase-input": {
                            marginTop: "-4px", // Adjust this value to move the text up
                            fontSize: 15,
                          },
                        }}
                        id="EFDV"
                        options={filteredUserData}
                        size="small"
                        
                        name="loamReviewer"
                        value={userData?.find(
                          (user) =>
                            user.userId ===
                            newFormState?.loamReviewer?.reviewerId
                        )}
                        getOptionLabel={(option) => option.userName}
                        getOptionDisabled={(option) =>
                          newFormState?.loamReviewer?.includes(
                            option?.userId
                          ) || false
                        }
                        loading={loading}
                        onChange={(event, newValue) => {
                          // autocompleteChangeHandler("RoleId", newValue);
                          // autocompleteChangeHandler("roleName", newValue?.roleName);
                          setNewFormState((formState) => ({
                            ...formState,
                            loamReviewer: newValue?.userId,
                          }));
                          if (
                            (newFormState?.loamReviewer !== undefined ||
                              newFormState?.loamReviewer !== "") &&
                            ReviewerMandatory[0]?.ReferenceProp5 == "True" &&
                            selectedRole?.roleName === "Department Coordinator"
                          ) {
                            setErrorMessage("");
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            size="small"
                            fullWidth
                            placeholder={
                              (newFormState.loamReviewer?.length || 0) === 0
                                ? "Select Reviewers"
                                : ""
                            }
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <>
                                  {loading ? (
                                    <CircularProgress
                                      color="inherit"
                                      size={20}
                                    />
                                  ) : null}
                                  {params.InputProps.endAdornment}
                                </>
                              ),
                            }}
                            required={RequiredReviwer}
                          />
                        )}
                      />
                        </Grid>

                  </Grid>
                </>
              )}
   {/* {(
  formState?.rtbId
) && (
  <Grid container spacing={2} marginY={2}>
    <Grid item xs={12}>
      <RTBLineItems_Table 
      formState={formState}
      setFormState={setFormState}
      setSelectedTotal={() => {}}
      selectedRole={selectedRole}
      />
    </Grid>
  </Grid>
)} */}
              {!formState?.isPCDV && (
                <>
                  {/* G/L Account */}
                  {!formState.isImport && newFormState.invoice_No && (
                    <>
                      <Grid container style={{ marginTop: "14px" }}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                          <Heading title="G/L Account" />
                          <GL_Table_V2
                          data={formState?.invoice_Accounts_list}
                            formState={newFormState}
                            setFormState={setNewFormState}
                            show={true}
                            reviwerFlag={reviwerFlag}
                            role={selectedRole}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={0} mt={1}>
                        <Grid item xs={12} sm={4} md={4} lg={2}>
                          <Typography
                            style={{
                              color: "#fff",
                              borderRadius: "2px",
                              padding: "10px",

                              // backgroundColor: "#4caf50",
                              backgroundColor: "#4caf50",
                            }}>
                          {`${formState.invoice_Type==='Final Settlement - Distributor' ? 'Customer Account Total' : 'Total GL Amount'} : ${totalGLAmount?.toLocaleString()}`}
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid container spacing={0} mt={1}>
                        <Grid xs={12} sm={4} md={4} lg={2}>
                          <Typography
                            style={{
                              color: "#fff",
                              borderRadius: "2px",
                              padding: "10px",

                              // backgroundColor: "#4caf50",
                              backgroundColor: "#888888",
                            }}>
                            Balance: {balance?.toLocaleString()}
                          </Typography>
                        </Grid>
                      </Grid>
                    </>
                  )}
               {
  formState?.isDeptCordinator && formState?.invoice_Type === 'Rent' && (
    <DepartmentCoordinatorRent 
      formState={formState}
      setFormState={setFormState}
      show={false}
      reviwerFlag={false}
      role={
        (selectedRole?.roleName === "Department Coordinator" && formState.invoice_Type === 'Rent')
          ? ""
          : "HR"
      }
    />
  )
}


                  {!formState.isImport &&
                    invoiceStatus !== "SendToReviewerFromSupervisor" && (
                      <Grid
                        container
                        spacing={1}
                        style={{ marginTop: "1px", padding: " 0px 5px " }}>
                        {/* Loam Approver */}
                        <Grid item xs={12} sm={12} md={3} lg={3}>
                          <Typography style={{ color: "black" }}>
                            <span className={classes.asterisk}>
                              {!newFormState?.isReturn ? "*" : ""}
                            </span>
                            Loam Approver:
                          </Typography>
                          <Autocomplete
                            sx={{
                              "& .MuiInputBase-root": {
                                height: "30px",
                                textAlign: "center",
                                display: "flex",
                                alignItems: "center",
                              },
                              "& .MuiInputBase-input": {
                                marginTop: "-4px", // Adjust this value to move the text up
                                fontSize: 15,
                              },
                            }}
                            size="small"
                            style={{ width: "100%" }}
                            disabled={reviwerFlag}
                            value={
                              loamUser.find((user) =>
                                user?.UserID
                                  ? user?.UserID === newFormState?.loam_approver
                                  : user?.Name === newFormState?.loam_approver
                              ) || ""
                            }
                            onChange={(e, newValue) => {
                              LoamUserHandler(newValue);
                            }}
                            options={loamUser}
                            getOptionLabel={(option) =>
                              option
                                ? option?.PersonalNumber
                                  ? `${option?.PersonalNumber} -` +
                                    `${option?.Name}`
                                  : `${option?.Name}`
                                : ""
                            }
                            loading={loamLoading}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                // variant="standard"
                                size="small"
                                // required
                                // InputProps={{
                                //   ...params.InputProps,
                                //   disableUnderline: true,
                                // }}
                                placeholder="Select loam Approver"
                                required={
                                  newFormState?.isProceed &&
                                  !newFormState?.isReturn
                                }
                              />
                            )}
                          />
                        </Grid>

                        {
                          (formState?.invoice_Type === "DES" && formState.isDeptCordinator )  &&
                          <Grid item xs={12} sm={12} md={6} lg={3}>
                          {/* <FormControl fullWidth size="small">
                        <UsersByRole
                          label="IP User"
                          apiString="IP"
                          name="ipUser"
                          placehold="Select a User"
                          formState={newFormState}
                          changeHandler={changeHandler}
                          // required={true}
                          required={newFormState?.isProceed}
                          classes={classes}
                        />
                      </FormControl> */}
                          <SearchUsersRole
                            label="IP User"
                            apiString="IP"
                            name="ipUser" // pending.
                            placeholder="Select a User"
                            formState={newFormState}
                            setNewFormState={setNewFormState}
                            changeHandler={changeHandler}
                            required={newFormState?.isProceed}
                            disabled={false}
                            classes={classes}
                          />
                        </Grid> 
                        }               
                        {/* Add Reviewer */}
                        <Grid item xs={12} sm={12} md={6} lg={3}>
                          <Typography style={{ color: "black" }}>
                            {RequiredReviwer ? (
                              <span className={classes.asterisk}>*</span>
                            ) : null}
                            Add Reviewer:{" "}
                          </Typography>
                          <Autocomplete
                            sx={{
                              "& .MuiInputBase-root": {
                                height:
                                  (newFormState.loamReviewer?.length || 0) === 0
                                    ? "30px"
                                    : "auto",
                                textAlign: "center",
                                display: "flex",
                                alignItems: "center",
                              },
                              "& .MuiInputBase-input": {
                                marginTop: "-4px",
                                fontSize: 15,
                              },
                            }}
                            multiple
                            options={filteredUserData || []} // Ensure options is never undefined
                            getOptionLabel={(option) => option.userName}
                            getOptionDisabled={(option) =>
                              newFormState?.loamReviewer?.includes(
                                option?.userId
                              ) || false
                            }
                            value={
                              newFormState?.loamReviewer?.map((reviewerId) =>
                                userData?.find(
                                  (user) => user.userId === reviewerId
                                )
                              ) || []
                            }
                            loading={loading}
                            onChange={(event, newValue) => {
                              setNewFormState((prevFormState) => ({
                                ...prevFormState,
                                loamReviewer:
                                  newValue?.map((user) => user?.userId) || [],
                              }));
                              if (
                                (newFormState?.loamReviewer !== undefined ||
                                  newFormState?.loamReviewer !== "") &&
                                ReviewerMandatory[0]?.ReferenceProp5 ==
                                  "True" &&
                                selectedRole?.roleName ===
                                  "Department Coordinator"
                              ) {
                                setErrorMessage("");
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="outlined"
                                size="small"
                                fullWidth
                                placeholder={
                                  (newFormState.loamReviewer?.length || 0) === 0
                                    ? "Select Reviewers"
                                    : ""
                                }
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: (
                                    <>
                                      {loading ? (
                                        <CircularProgress
                                          color="inherit"
                                          size={20}
                                        />
                                      ) : null}
                                      {params.InputProps.endAdornment}
                                    </>
                                  ),
                                }}
                                required={RequiredReviwer}
                              />
                            )}
                            renderTags={(value, getTagProps) =>
                              value.map((option, index) => (
                                <Chip
                                  key={index}
                                  label={option?.userName}
                                  onDelete={() => {
                                    const updatedReviewers =
                                      newFormState?.loamReviewer?.filter(
                                        (userId) => userId !== option.userId
                                      ) || [];
                                    setNewFormState((prevFormState) => ({
                                      ...prevFormState,
                                      loamReviewer: updatedReviewers,
                                    }));
                                  }}
                                  deleteIcon={<CloseIcon />}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    backgroundColor: "#e0e0e0",
                                    padding: "2px",
                                    marginRight: "4px",
                                  }}
                                  {...getTagProps({ index })}
                                />
                              ))
                            }
                          />
                        </Grid>    
                              
           {
         (  newFormState?.loamReviewer?.length > 0 && (invoiceStatus == 'SendToDeptCoordinator'  || invoiceStatus == 'SendToDeptCoordinatorFromReviewer'
          || invoiceStatus == 'SendToDeptCoordinatorFromLoamApprover'
         )) && 
            <Grid
            item xs={12} sm={12} md={6} lg={3}
          >
            <FormControl component="fieldset">
              <Typography style={{
                color: "black"
              }}>
               Sequential/Parallel
              </Typography>
              <RadioGroup
                row
                aria-label="gender"
                name="gender1"
                value={isParallel}
                aria-labelledby="demo-row-radio-buttons-group-label"
                onChange={ (e)=>{
                  setIsParallel(e.target.value)
                }}        
              >
                <FormControlLabel
                 value= "Sequential"
                  control={<Radio size="small" />}
                  label="Sequential"
                  style={{ color: "black" }} 
                />
                <FormControlLabel
               value = "Parallel"
                  control={<Radio size="small" />}
                  label="Parallel"
                  style={{ color: "black" }}
                 
                />
              </RadioGroup>
            </FormControl>
          </Grid>
           }
         
                        {/*
                  <Grid item xs={12} sm={12} md={3} lg={3}>
                    <Button
                      color="secondary"
                      variant="contained"
                      sx={{ mt: 3 }}
                    >
                      Add Another Reviewer
                    </Button>
                  </Grid>
                      */}
                      </Grid>
                    )}
                </>
              )}

              <Grid
                container
                spacing={2}
                style={{ marginTop: "1px", padding: " 0px 5px " }}>
                <Grid item xs={12} sm={12} md={12} lg={3}>
                  <Typography style={{ color: "black" }}>
                    Additional Documents:
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    f
                    sx={{
                      "& .MuiInputBase-root": {
                        height: 30,
                      },
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },
                    }}
                    id="outlined-basic"
                    variant="outlined"
                    // onChange={() => }
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <input
                            ref={additionalAttachmentRef}
                            type="file"
                            name="additionalDocIds"
                            // accept=".png, .jpg, .jpeg, .pdf"
                            // required={
                            //   newFormState?.isReject === false
                            //     ? newFormState?.additionalDocIds.length === 0
                            //     : false
                            // }
                            onChange={(e) =>
                              uploadAdditioalDocumentFile(
                                e,
                                setNewFormState,
                                setAttachInvoiceLoading,
                                "additionalDocIds",
                                additionalAttachmentRef,
                                setDocError,
                                setAttachError,
                                setAlertMessage,
                                invoicePayload,
                                selectedRole,
                                dragfile,
                                setDragFile,
                                setSuccessMessage
                              )
                            }
                            style={{ width: "209px" }}
                            multiple
                          />
                        </InputAdornment>
                      ),
                    }}
                  />
                  {newFormState?.additionalDocIds?.length > 0 &&
                    newFormState?.additionalDocIds?.map((f, index) => {
                      const s = f?.path?.split("\\");
                      const ss = s[s.length - 1];
                      return (
                        <>
                          {f?.path !== "" ? (
                            <>
                              <IconButton
                                size="small"
                                disabled={
                                  f.role_Name !== selectedRole?.roleName
                                }
                                onClick={() => {
                                  setInvoiceDelete(f);
                                  setWarningFlag(true);
                                }}>
                                <Delete color="danger" fontSize="small" />
                              </IconButton>
                              <IconButton size="small">
                                <Download
                                  onClick={() => {
                                    const files =
                                      newFormState.additionalDocIds.find(
                                        (x, i) => {
                                          const n = x?.path?.split("\\");
                                          const nn = n[n.length - 1];
                                          return nn === ss;
                                        }
                                      );
                                    downloadAttachments(files?.path);
                                  }}
                                />
                              </IconButton>

                              <IconButton
                                size="small"
                                onClick={() => {
                                  const extension = f.path
                                    ?.match(/\.[^.]+$/)[0]
                                    .substring(1);

                                  const allowedExtensions = [
                                    ".png",
                                    ".pdf",
                                    ".jpg",
                                    ".jpeg",
                                    ".PNG",
                                    ".JPG",
                                    ".JPEG",
                                    ".PNG",
                                    ".PDF",
                                  ];
                                  const fileExtension =
                                    "." + ss.split(".").pop();
                                  if (
                                    allowedExtensions.includes(fileExtension)
                                  ) {
                                    setAttachmentURL(f);
                                  } else {
                                    if (isContainEmailFormate(extension)) {
                                      downloadAttachments(f.path);
                                    } else {
                                      setAttachmentURL(f);

                                      window.open(
                                        `${process.env.REACT_APP_API_URL}/${f.path}`,
                                        "_blank"
                                      );
                                    }
                                  }
                                }}>
                                <span style={{ fontSize: "10px" }}>{ss}</span>
                              </IconButton>
                              <div></div>
                            </>
                          ) : (
                            ""
                          )}
                        </>
                      );
                    })}
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <CommentHistory
                  commentsList={commentsList}
                  commentsLoading={commentsLoading}
                />
              </Grid>
              <Grid
                container
                style={{ margin: "20px 0px", padding: "0px 5px" }}>
                {/* Additional Details */}

                {/* Comments */}
                <Grid item xs={12} sm={12} md={6} lg={12}>
                  <Typography style={{ color: "black" }}>
                    Comments:{" "}
                    {(newFormState?.isReject || newFormState.isReturn || invoiceStatus == "SendToReviewerFromIR" || invoiceStatus == "SendToReviewerFromIP") ? (
                      <span className={classes.asterisk}>*</span>
                    ) : null}
                  </Typography>

                  <TextField
                    fullWidth
                    multiline
                    rows={2}
                    maxRows={4}
                    // size="small"
                    sx={{
                      // width: "70%",
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },
                    }}
                    id="outlined-basic"
                    variant="outlined"
                    name="comments"
                    required={(newFormState?.isReject || newFormState?.isReturn  || invoiceStatus == "SendToReviewerFromIR" || invoiceStatus == "SendToReviewerFromIP")}
                    value={newFormState.comments}
                    onChange={(e) => {
                      setNewFormState({
                        ...newFormState,
                        comments: e.target.value,
                      });
                    }}
                  />
                  {!formState?.isPCDV &&
                    !formState.isImport &&
                    invoiceStatus !== "SendToReviewerFromSupervisor" && (
                      <Grid item xs={12} sm={12} md={6} lg={12}>
                        <Typography style={{ color: "black" }}>
                          Additional Details:
                        </Typography>
                        <TextField
                          fullWidth
                          multiline
                          rows={2}
                          maxRows={4}
                          // size="small"
                          sx={{
                            // width: "70%",
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                          }}
                          id="outlined-basic"
                          variant="outlined"
                          name="aditional_Comments"
                          // required={newFormState?.isProceed && poBasedState == "PO"}
                          value={newFormState.aditional_Comments}
                          onChange={(e) => {
                            setNewFormState({
                              ...newFormState,
                              aditional_Comments: e.target.value,
                            });
                          }}
                        />
                      </Grid>
                    )}

                   {!reviwerFlag && !formState.isPCDV ? (
                    <Box display="flex" justifyContent={"flex-end"} mt={2}>
                      {(Post && allowToProceed) && (
                        <>
                          <Button
                            color="error"
                            variant="contained"
                            onClick={() => navigate("/home")}>
                            Cancel
                          </Button>
                       {formState.isDeptCordinator ? (
                          <Button
                            color="secondary"
                            style={{
                              color: "white",
                              backgroundColor: "black",
                            }}
                            variant="contained"
                            type="submit"
                            sx={{ ml: 2 }}
                            onClick={() => {
                              setNewFormState({
                                ...newFormState,
                                isReturn: false,
                                isProceed: false,
                                isDelete: true,
                              });
                              setStatusForPayload("Deleted");
                            }}
                          >
                            Delete Invoice
                          </Button>
 
                        ) : (
                          <Button
                            color="secondary"
                            variant="contained"
                            type="submit"
                            sx={{ ml: 2 }}
                            onClick={() => {
                              setNewFormState({
                                ...newFormState,
                                isReturn: true,
                                isProceed: false,
                              });
                              setConfirmationMessage(
                                "Are you sure to send invoice to Invoice Receiver"
                              );
                              setStatusForPayload(
                                "SendToIRFromDeptCoordinator"
                              );
                              // setConfirmationModal(true);
                            }}>
                            Return to Invoice Receiver
                          </Button>
                        )}
                          <Button
                            color="secondary"
                            variant="contained"
                            type="submit"
                            sx={{ ml: 2 }}
                            onClick={() => {
                              setNewFormState({
                                ...newFormState,
                                isReturn: false,
                                isDelete: false,
                                isProceed: true,
                              });
                            }}>
                            Initiate Loam Approval
                          </Button>
                        </>
                      )}
                    </Box>
                  ) : (
                    <>
                      {(Post && allowToProceed) && (
                        <Box display="flex" justifyContent={"flex-end"} mt={2}>
                          {formState.isPCDV &&
                            (invoiceStatus === "SendToReviewer2" ||
                              invoiceStatus === "SendToReviewer2FromLoamApprover" ||
                              invoiceStatus === "SendToDeptCoordinator") && (
                              <Button
                                color="primary"
                                variant="contained"
                                type="submit"
                                onClick={() => {
                                  setNewFormState({
                                    ...newFormState,
                                    isReturn: true,
                                  });
                                  setConfirmationMessage(
                                    "Are you sure to send invoice to Initiator"
                                  );
                                  setStatusForPayload(
                                    formState.isPCDV
                                      ? "SendToEfdvInitiatorFromReviewer"
                                      : "SendToInitiatorFromDeptCoordinator"
                                  );
                                }}>
                                Send to Initiator
                              </Button>
                            )}
                          <Button
                            color="error"
                            variant="contained"
                            sx={{ ml: 2 }}
                            type="submit"
                            onClick={() =>
                              setNewFormState({
                                ...newFormState,
                                isReject: true,
                                isProceed: false,
                              })
                            }>
                            Reject
                          </Button>
                          <Button
                            color="secondary"
                            variant="contained"
                            type="submit"
                            sx={{ ml: 2 }}
                            onClick={() =>
                              setNewFormState({
                                ...newFormState,
                                isReturn: false,
                                isReject: false,
                                isProceed: true,
                              })
                            }>
                            Approve
                          </Button>
                        </Box>
                      )}
                    </>
                  )}
                </Grid>
              </Grid>
            </form>
            {confirmationModal && (
              <ConfirmationModal
                open={confirmationModal}
                close={() => setConfirmationModal(false)}
                message={confirmationMessage}
                submit={submitHandler}
                loading={attachInvoiceLoading}
              />
            )}
            {openWarningBox && (
              <WarningBox
                open={openWarningBox}
                close={() => setOpenWarningBox(false)}
                submit={submitHandler}
                message={
 newFormState?.isDelete === true
    ? "Are you sure you want to Delete the Invoice"
    : newFormState?.isReject === true

                    ? "Are you sure you want to Reject the Invoice"
                    : "Are you sure to Proceed the invoice"
                }
              />
            )}
            {successMessage && (
              <CustomSnackbar
                open={successMessage !== ""}
                message={successMessage}
                handleClose={() => setSuccessMessage("")}
                variant="success"
              />
            )}
            {errorMessage && (
              <>
                {" "}
                <Grid container spacing={0}>
                  <Grid item>
                    <Error
                      titleAccess="Error"
                      className={classes.asterisk}
                      fontSize="small"
                    />{" "}
                  </Grid>
                  <Grid item>
                    <Typography className={classes.asterisk} ml={1}>
                      {" "}
                      {errorMessage}
                    </Typography>
                  </Grid>
                </Grid>
              </>
            )}
            {warningFlag && (
              <WarningBox
                open={warningFlag}
                close={() => setWarningFlag(false)}
                submit={deleteAttachmentFunc}
                message="Are you sure to delete attachment"
                deleteLoader={deleteLoader}
                allow={1}
              />
            )}
            {alertMessage && (
              <POAlertDialog
                setAlertMessage={setAlertMessage}
                message={attachError ? attachError : docError}
                setErrAlertMessage={() => {}}
              />
            )}
            {specialCharError && (
              <POAlertDialog
                setAlertMessage={setSpecialCharError}
                message="Invoice Decription should not contain any Special character"
                setErrAlertMessage={() => {}}
              />
            )}
            {higherLoamApprover && (
              <POAlertDialog
                setAlertMessage={sethigherLoamApprover}
                message="You have selected a higher-order Loam Approver!"
                setErrAlertMessage={() => {}}
              />
            )}
          </CardBody>
        </Card>
      {/* ) : (
        <PageNotFound />
      )} */}
    </>
  );
};

export default Department;
